'use strict';

angular.module('mean.options').factory('optionService', ['$filter', 'toaster', 'Options', 'aceUtils', 'taskTotalsService',
    function($filter, toaster, Options, aceUtils, taskTotalsService) {
        //get an array of options for passed in lot/trade from the passed in options
        //options ($scope.trade_options.options)
        //number (lot.number)
        //trades (item.trades)
        var getTradeOptions = function(options, number, trades) {
            var ret_options = [];
            console.log('in getTradeOptions');
            // get the trade_options associated with this option selection
            _.each(trades, function(trade) {
                var opts = $filter('filter')(options, { 'number': number }, true);
                if(opts.length === 1) {
                    ret_options.push(opts[0]);
                } else {
                    toaster.pop('error', 'Trade Option', 'Trade option not found.');
                    return null;
                }
            });

            return ret_options;
        };

        //options are the trade options returned from getTradeOptions
        //plan is the lot's plan.
        var filterOptionSubtasksOnPlans = function(options, plan) {
            var ret_subtasks = [];

            // filter out plans for each trade option
            _.each(options, function(option) {
                var subs = $filter('filter')(option.subtasks, {
                    'plan': plan,
                    'revision': (option.revision.number)?option.revision.number:option.revision }, true);
                _.each(subs, function(sub) {
                    ret_subtasks.push(sub);
                });
                //subs are all the subtasks that need to get
                //replaced in the ProjectBids.
            });

            return ret_subtasks;
        };

        //this will take the option materials and apply
        //the changes to the bid_materials
        //materials (subtask.materials)
        //bid_materials (bids[0].materials)
        var optionMaterialAddOrUpdate = function(item, lot, materials,
            bid_materials, bid_sub, multiple) {
            // iterate over each option subtask materials
            // see if material exists in project bid.
            // if found, update information.  If not, add
            _.each(materials, function(material) {
                // if(material.material_id) {
                //     // this material is in the original bid
                //     // update project bid with new data
                //     var bid_mat = $filter('filter')(bid_materials, {
                //         'material_id': material.material_id }, true);

                //     if(bid_mat.length !== 1) {
                //         toaster.pop('error', 'Bid Material',
                //             'Problem getting material ' + material.name +
                //             ' with bid note ' + material.note +
                //             ' for option ' + item.number + ' (' + bid_sub.name +
                //             ').  Remove and readd material in option edit to try and correct.' +
                //             '  If that does not fix it, then contact admin.');
                //     } else {
                //         bid_mat[0].quantity = (aceUtils.isUndefinedOrZero(material.quantity))?
                //             material.quantity_allowed: material.quantity;

                //         // if(is_multiple) {
                //         //     bid_mat[0].quantity *= item.multiple;
                //         // }

                //         //this will apply the multiple in the view when
                //         //initially turned on.
                //         bid_mat[0].is_multiple = (multiple>1)?true:false;
                //         if(!bid_mat[0].multi_data) bid_mat[0].multi_data = [];

                //         var lot_num = (lot.lot)?lot.lot:lot.number;
                //         var inlist = $filter('filter')(bid_mat[0].multi_data, {
                //             'option_number': item.number, 'lot': lot_num, 'phase': lot.phase }, true);

                //         if(inlist.length === 0) {
                //             bid_mat[0].multi_data.push({
                //                 option_number: item.number,
                //                 multiple: item.multiple,
                //                 lot: lot_num,
                //                 phase: lot.phase
                //             });
                //         } else {
                //             inlist[0].multiple = item.multiple;
                //         }

                //         bid_mat[0].is_option = true;
                //         bid_mat[0].is_original = true;

                //         if(!bid_mat[0].option_revision) bid_mat[0].option_revision = [];

                //         bid_mat[0].option_revision.push({
                //             number: item.revision,
                //             quantity: (aceUtils.isUndefinedOrZero(material.quantity))?
                //                 material.quantity_allowed: material.quantity,
                //             price_per_order: material.price_per_order,
                //             delivery_price: material.delivery_price,
                //             unit: material.unit,
                //             lot: (lot.lot)?lot.lot:lot.number,
                //             phase: lot.phase
                //         });

                //         bid_mat[0].option_number = item.number;

                //         if(bid_mat[0].unit === bid_sub.unit) {
                //             bid_mat[0].price_per_order = material.price_per_order * item.multiple;
                //             bid_mat[0].delivery_price = material.delivery_price * item.multiple;
                //             bid_mat[0].unit = material.unit;

                //             bid_mat[0].materials_subtotal = material.materials_subtota * item.multiplel;
                //             bid_mat[0].materials_dev_subtotal = material.materials_dev_subtotal * item.multiple;

                //             bid_sub.materials_dev_subtotal += bid_mat[0].materials_dev_subtotal;
                //             bid_sub.materials_subtotal += bid_mat[0].materials_subtotal;
                //         } else {
                //             bid_mat[0].materials_subtotal = 0;
                //             bid_mat[0].materials_dev_subtotal = 0;

                //             bid_sub.materials_dev_subtotal += bid_mat[0].materials_dev_subtotal;
                //             bid_sub.materials_subtotal += bid_mat[0].materials_subtotal;
                //         }
                //     }
                // } else {
                    // if(is_multiple) {
                    //     material.quantity_allowed *= item.multiple;
                    //     material.quantity *= item.multiple;
                    // }
                    // this is a new material.  just add.
                    bid_materials.push({
                        supplier: material.supplier,
                        name: material.name,
                        isInventory: material.isInventory || false,
                        quantity: (aceUtils.isUndefinedOrZero(material.quantity))?
                            material.quantity_allowed: material.quantity,
                        is_option: true,
                        is_original: false,
                        is_multiple: (multiple>1)?true:false,
                        multi_data: {
                            option_number: item.number,
                            multiple: multiple,
                            lot: (lot.lot)?lot.lot:lot.number,
                            phase: lot.phase
                        },
                        option_revision: {
                            number: item.revision,
                            quantity: (aceUtils.isUndefinedOrZero(material.quantity))?
                                material.quantity_allowed: material.quantity,
                            price_per_order: material.price_per_order,
                            delivery_price: material.delivery_price,
                            unit: material.unit,
                            lot: (lot.lot)?lot.lot:lot.number,
                            phase: lot.phase
                        },
                        option_number: item.number,
                        material_id: new Date().getTime(),
                        price_per_order: material.price_per_order * multiple,
                        delivery_price: material.delivery_price * multiple,
                        materials_subtotal: material.materials_subtotal * multiple,
                        materials_dev_subtotal: material.materials_dev_subtotal * multiple,
                        delivery_offset: material.delivery_offset,
                        description: material.description,
                        note: material.note,
                        unit: material.unit,
                        color_scheme: material.color_scheme,

                    });

                    //bid_sub.material_total += material.material_total;
                    bid_sub.materials_dev_subtotal += material.materials_dev_subtotal;
                    bid_sub.materials_subtotal += material.materials_subtotal;
                // }
            });
        };

        var addUpBidSubtaskMaterialTotal = function(bid_sub, bid_materials, sales_tax) {
            bid_sub.material_total = 0;
            _.each(bid_materials, function(material) {
                if(material.materials_subtotal) {
                    bid_sub.material_total += material.materials_subtotal +
                            (material.materials_subtotal * sales_tax);
                }

                if(material.materials_dev_subtotal) {
                    bid_sub.material_total += material.materials_dev_subtotal;
                }
            });
        };

        //this will take the option materials and apply
        //the changes to the bid_materials
        //materials (subtask.materials)
        //bid_materials (bids[0].materials)
        var optionEquipmentAddOrUpdate = function(item, lot, equipments,
            bid_equipment, bid_sub, multiple) {
            // iterate over each option subtask materials
            // see if material exists in project bid.
            // if found, update information.  If not, add
            _.each(equipments, function(equipment) {
                // if(equipment.equipment_id) {
                //     // this material is in the original bid
                //     // update project bid with new data
                //     var bid_mat = $filter('filter')(bid_equipment, {
                //         'equipment_id': equipment.equipment_id }, true);

                //     if(bid_mat.length !== 1) {
                //         toaster.pop('error', 'Bid Equipment',
                //             'Problem getting equipment ' + equipment.name +
                //             ' with bid note ' + equipment.note +
                //             ' for subtask ' + subtask.name + ' (' + subtask.code +
                //             ').  Remove and readd equipment in option edit to try and correct.' +
                //             '  If that does not fix it, then contact admin.');
                //     } else {
                //         bid_mat[0].quantity = (aceUtils.isUndefinedOrZero(equipment.quantity))?
                //             equipment.quantity_allowed: equipment.quantity;

                //         //this will apply the multiple in the view when
                //         //initially turned on.
                //         bid_mat[0].is_multiple = (multiple>1)?true:false;
                //         if(!bid_mat[0].multi_data) bid_mat[0].multi_data = [];
                //         bid_mat[0].multi_data.push({
                //             option_number: item.number,
                //             multiple: item.multiple,
                //             lot: (lot.lot)?lot.lot:lot.number,
                //             phase: lot.phase
                //         });

                //         if(!bid_mat[0].option_revision) bid_mat[0].option_revision = [];

                //         bid_mat[0].option_revision.push({
                //             number: item.revision,
                //             quantity: (aceUtils.isUndefinedOrZero(equipment.quantity))?
                //                 equipment.quantity_allowed: equipment.quantity,
                //             price_per_order: equipment.price_per_order,
                //             delivery_price: equipment.delivery_price,
                //             unit: equipment.unit,
                //             lot: (lot.lot)?lot.lot:lot.number,
                //             phase: lot.phase
                //         });

                //         bid_mat[0].option_number = item.number;

                //         bid_mat[0].price_per_order = equipment.price_per_order * item.multiple;
                //         bid_mat[0].delivery_price = equipment.delivery_price * item.multiple;
                //         bid_mat[0].unit = equipment.unit;

                //         bid_mat[0].equipment_subtotal = equipment.equipment_subtotal * item.multiple;
                //         bid_mat[0].equipment_dev_subtotal = equipment.equipment_dev_subtotal * item.multiple;

                //         bid_sub.equipment_dev_subtotal += bid_mat[0].equipment_dev_subtotal;
                //         bid_sub.equipment_subtotal += bid_mat[0].equipment_subtotal;
                //     }
                // } else {
                    // this is a new material.  just add.
                    bid_equipment.push({
                        supplier: equipment.supplier,
                        name: equipment.name,
                        quantity: (aceUtils.isUndefinedOrZero(equipment.quantity))?
                            equipment.quantity_allowed: equipment.quantity,
                        is_option: true,
                        is_original: false,
                        is_multiple: (multiple>1)?true:false,
                        multi_data: {
                            option_number: item.number,
                            multiple: multiple,
                            lot: (lot.lot)?lot.lot:lot.number,
                            phase: lot.phase
                        },
                        option_revision: {
                            number: item.revision,
                            quantity: (aceUtils.isUndefinedOrZero(equipment.quantity))?
                                equipment.quantity_allowed: equipment.quantity,
                            price_per_order: equipment.price_per_order,
                            delivery_price: equipment.delivery_price,
                            unit: equipment.unit,
                            lot: (lot.lot)?lot.lot:lot.number,
                            phase: lot.phase
                        },
                        option_number: item.number,
                        equipment_id: new Date().getTime(),
                        price_per_order: equipment.price_per_order * multiple,
                        delivery_price: equipment.delivery_price * multiple,
                        equipment_subtotal: equipment.equipment_subtotal * multiple,
                        equipment_dev_subtotal: equipment.equipment_dev_subtotal * multiple,
                        delivery_offset: equipment.delivery_offset,
                        description: equipment.description,
                        note: equipment.note,
                        unit: equipment.unit,
                        color_scheme: equipment.color_scheme
                    });

                    bid_sub.equipment_dev_subtotal += equipment.equipment_dev_subtotal;
                    bid_sub.equipment_subtotal += equipment.equipment_subtotal;
                //}
            });
        };

        var addUpBidSubtaskEquipmentTotal = function(bid_sub, bid_equipments, sales_tax) {
            bid_sub.equipment_total = 0;
            _.each(bid_equipments, function(equipment) {
                bid_sub.equipment_total += equipment.equipment_subtotal +
                        (equipment.equipment_subtotal * sales_tax);
                bid_sub.equipment_total += equipment.equipment_dev_subtotal;
            });
        };

        //subtask_materials is (subtask.materials)
        //replacement_materials is (replacement.materials)
        //bid_materials is (bids[0].materials)
        var removeOptionMaterialsFromBidSubtask = function(
            subtask_materials, replacement_materials, bid_materials) {
            // iterate over each option subtask materials
            // see if material exists in project bid.
            // if found, update information.  If not, add
            var removed_all_by_option = false;
            _.each(subtask_materials, function(material) {
                if(material.material_id) {
                    // this material is in the original bid
                    // update project bid with orig data
                    var orig_mat = $filter('filter')(replacement_materials, {
                        '_id': material.material_id }, true);

                    var bid_mat = $filter('filter')(bid_materials, {
                        'material_id': material.material_id }, true);

                    if(orig_mat.length !== 1) {
                        toaster.pop('error', 'Bid Material',
                            'Problem getting original material. Contact Admin.');
                    } else {
                        if(bid_mat.length !== 1) {
                            toaster.pop('error', 'Bid Material',
                                'Problem getting bid material. Contact Admin.');
                        } else {
                            _.remove(bid_mat[0].multi_data, function(data) {
                                return data.is_option && data.option_number === item.number &&
                                    data.lot === lot.lot && data.phase === lot.phase;
                            });

                            bid_mat[0].quantity = (aceUtils.isUndefinedOrZero(orig_mat[0].quantity))?
                                orig_mat[0].quantity_allowed: orig_mat[0].quantity;
                            bid_mat[0].price_per_order = orig_mat[0].price_per_order;
                            bid_mat[0].delivery_price = orig_mat[0].delivery_price;
                            bid_mat[0].materials_subtotal = orig_mat[0].materials_subtotal;
                            bid_mat[0].materials_dev_subtotal = orig_mat[0].materials_dev_subtotal;
                            bid_mat[0].unit = orig_mat[0].unit;
                        }
                    }
                } else {
                    // this is a new material.  gonna have to do an inital search and
                    // narrow if needed.
                    var inlist = $filter('filter')(bid_materials, {
                        'supplier': material.supplier,
                        'unit': material.unit,
                        'name': material.name,
                        'description': material.description }, true);

                    if(inlist.length === 1 && !removed_all_by_option) {
                        var idx = bid_materials.indexOf(inlist[0]);
                        bid_materials.splice(idx, 1);

                        var removed = _.remove(inlist[0].multi_data, function(data) {
                            return data.option_number === item.number &&
                                data.lot === lot.lot && data.phase === lot.phase;
                        });
                        console.log(removed);
                    } else if(inlist.length > 1){
                        // this means we have multiple of the same material
                        // lets see if we can narrow down
                        // first lets only look at option materials
                        var new_list = [];
                        _.each(inlist, function(mat) {
                            if(mat.is_option) {
                                new_list.push(mat);
                            }
                        });

                        if(new_list.length === 1) {
                            //found the one we're looking for
                            var idx = bid_materials.indexOf(new_list[0]);
                            bid_materials.splice(idx, 1);
                            _.remove(new_list[0].multi_data, function(data) {
                                return data.is_option && data.option_number === item.number &&
                                    data.lot === lot.lot && data.phase === lot.phase;
                            });
                        } else if(new_list.length > 1) {
                            inlist = $filter('filter')(new_list, {
                                'price_per_order': material.price_per_order,
                                'delivery_price': material.delivery_price }, true);

                            if(inlist.length === 0) {
                                toaster.pop('error', 'Finding Material',
                                    'Could not determine material to be removed');
                            } else if(inlist.length === 1) {
                                //found the one we're looking for
                                var idx = bid_materials.indexOf(inlist[0]);
                                bid_materials.splice(idx, 1);
                                _.remove(inlist[0].multi_data, function(data) {
                                    return data.is_option && data.option_number === item.number &&
                                        data.lot === lot.lot && data.phase === lot.phase;
                                });
                            } else {
                                //still too many of the same material but
                                //i think we can safely remove.
                                var got_removed = false;
                                var remove_indexs = [];

                                _.each(bid_materials, function(mat, index) {
                                    var isInList = $filter('filter')(mat.multi_data, {
                                        'option_number': item.number, 'lot': lot.lot,
                                        'phase': lot.phase}, true);

                                    if(isInList.length === 1) {
                                        remove_indexs.push(index)
                                    } else if(isInList.length > 1) {
                                        toaster.pop('error', 'This is a Problem');
                                    }
                                });

                                if(remove_indexs.length === 1) {
                                    var idx = bid_materials.indexOf(remove_indexs[0]);
                                    bid_materials.splice(idx, 1);
                                } else if(remove_indexs.length > 1) {
                                    removed_all_by_option = true;
                                    remove_indexs = $filter('orderBy')(remove_indexs, {});
                                    for(var i = remove_indexs.length-1; i >= 0; i--) {
                                        bid_materials.splice(remove_indexs[i], 1);
                                    }
                                } else {
                                    _.remove(bid_materials, function(rItem) {
                                        return rItem.supplier === material.supplier &&
                                            rItem.unit === material.unit &&
                                            rItem.name === material.name &&
                                            rItem.description === material.description &&
                                            rItem.price_per_order === material.price_per_order &&
                                            rItem.delivery_price === material.delivery_price &&
                                            rItem.is_option;
                                    });
                                }
                            }
                        } else {
                            toaster.pop('error', 'Finding Material',
                                'Could not determine material to be removed');
                        }
                    }
                }
            });
        };

        return {
            getTradeOptions: getTradeOptions,
            filterOptionSubtasksOnPlans: filterOptionSubtasksOnPlans,
            optionMaterialAddOrUpdate: optionMaterialAddOrUpdate,
            addUpBidSubtaskMaterialTotal: addUpBidSubtaskMaterialTotal,
            optionEquipmentAddOrUpdate: optionEquipmentAddOrUpdate,
            addUpBidSubtaskEquipmentTotal: addUpBidSubtaskEquipmentTotal,
            removeOptionMaterialsFromBidSubtask: removeOptionMaterialsFromBidSubtask
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/options/public/services/option-service.js